export default "__VITE_ASSET__DTNtfdJz__"